import FingerprintJS from "@fingerprintjs/fingerprintjs"
import AES from "crypto-js/aes"
import { cloneElement, createElement } from "react"

const encryptKey = import.meta.env.VITE_APP_ENCRYPT_KEY

export function defineElement(element, props = {}) {
  if (element) {
    return typeof element === "function"
      ? createElement(element, props)
      : cloneElement(element, props)
  }

  return null
}

export const capitalizeFirstLetter = (str: string): string => {
  if (str) {
    return str.charAt(0).toUpperCase() + str.slice(1)
  }
  return ""
}

export const encrypt = (message) => {
  return AES.encrypt(message, encryptKey).toString()
}

export const getVisitorId = async () => {
  const fp = await FingerprintJS.load()
  const result = await fp.get()
  return result.visitorId
}

export const generateListNumber = (numberLength: number) => {
  return Array.from(Array(numberLength), (_, x) => x)
}
